export default "__VITE_ASSET__D5UTm7Um__"